











import Vue from 'vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import prefectures from '@/packages/Prefectures'

type Methods = {
  onChange: (v: Props['value']) => void
}

type Computed = {
  options: OptionEntry<number | undefined>[]
}

type Props = {
  value?: number
  rules?: string | Record<string, boolean>
}

export default Vue.extend<{}, Methods, Computed, Props>({
  inheritAttrs: false,
  name: 'PrefPicker',
  components: { XDropdown },
  props: {
    value: {
      type: Number,
      required: false,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
    // ...rest (inherit attrs from x-dropdown)
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
    },
  },
  computed: {
    options() {
      const options = prefectures().map((e) => {
        return { value: e.id, label: e.name }
      })

      const emptyOpt = { value: undefined, label: '' }
      return [emptyOpt, ...options]
    },
  },
})
